export default {

    methods: {

        centsToMoneyFormat(amount) {
            if (String(amount)[0] == '-') {
                let newAmount = String(amount).split('-')[1]
                return '-$' + (newAmount / 100)
            }
            return '$' + (amount / 100)
        },

        refreshTooltips() {
            this.$nextTick(() => {
                $('[data-toggle="tooltip"]').tooltip()
            })
        },

        capitalize(str, lower = false) {
            return (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
        },


        shortDateTime(value) {
            return moment(value).format('MMMM DD, YYYY - h:mm A');
        },

        shortDate(value, timezone = null) {
            timezone = timezone ? timezone : window.clientTimeZone
            return moment(value).tz(timezone).format("MMM DD, YYYY");
        },

        smallDate(value) {
            return moment(value).format("ddd DD, YY");
        },

        descriptiveDate(value) {
            return moment(value).format("dddd MMMM DD, YYYY");
        },

        strlimit(string, limit = 10, completion = '...') {
            if (string.length > limit) {
                return string.substring(0, limit) + completion
            } else {
                return string;
            }
        },

        redirectTo(url, type) {
            if (type == '_blank') {
                window.open(url, type);
                return;
            }
            window.location.href = url;
        },

        refreshPage() {
            location.reload();
        },

        slug(value) {
            return slugify(value, {
                lower: true
            })
        },

        pluralize(string, count, prefix = false) {
            return window.pluralize(string, count, prefix)
        },

        textProviderClass(provider) {
            return {
                "text-purple": (provider == "schedule"),
                "text-info": (provider == "career-safe"),
                "text-primary": ["eleap", "eleap-training-path"].includes(provider),
                "text-warning": ["mike-holt-offline", "mike-holt"].includes(provider)
            }
        }
    },
}
